import firebase from "firebase";

// Initialize Firebase
const config = {

  databaseURL: "https://saludfemeninaliomont.firebaseio.com",
  apiKey: "AIzaSyCWSgEEp1yQofYyMLAavAbIq65Nv6EtUt0",
  authDomain: "saludfemeninaliomont.firebaseapp.com",
  projectId: "saludfemeninaliomont",
  storageBucket: "saludfemeninaliomont.appspot.com",
  messagingSenderId: "130122589831",
  appId: "1:130122589831:web:6088402964b01a5b607a22",
  measurementId: "G-GPT9E6DED2"
};
firebase.initializeApp(config);
firebase.auth().languageCode = 'es'
const auth = firebase.auth();
const functions = firebase.functions();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.firestore();

export {
  database,
  auth,
  functions,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
